<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path
			d="M7.417 11.448c2.954 0 5.226-1.288 5.226-3.106V5.086c0-1.818-2.272-3.106-5.226-3.106-2.953 0-5.226 1.288-5.226 3.106v3.256c0 1.818 2.273 3.106 5.226 3.106M3.1 5.01c.076-1.212 1.894-2.196 4.317-2.196s4.242.984 4.317 2.12c-.151.985-1.893 1.742-4.317 1.742C4.691 6.676 3.1 6.07 3.1 5.01m0 1.59c.91.682 2.348.985 4.317.985 1.894 0 3.409-.379 4.317-1.136v1.893c0 1.212-1.817 2.272-4.317 2.272S3.1 9.555 3.1 8.343z"
		/>
		<path
			d="M22.337.694c-.076 0-.076 0-.076-.076-1.515-.833-3.408-.227-4.241 1.287L10.9 15.463l-5.226-1.667c-.378-.151-.833-.151-1.212-.227-2.272 0-4.165 1.818-4.165 4.09v1.818a4.073 4.073 0 0 0 4.09 4.09h7.27c1.364 0 2.651-.758 3.257-1.97l8.71-16.51c.833-1.591.228-3.484-1.287-4.393M13.4 20.916c-.38.681-.985 1.06-1.742 1.06H4.387c-1.288 0-2.424-1.06-2.424-2.424v-1.817c0-1.288 1.06-2.348 2.424-2.348.227 0 .454.076.681.076l5.226 1.666c.758.227 1.59-.076 1.97-.833l3.71-7.044 2.576 1.515zm5.68-10.907-2.575-1.514.833-1.59 2.575 1.514zm3.03-5.68-1.742 3.333-2.576-1.515 1.742-3.333c.38-.681 1.212-.984 1.894-.606h.076c.681.38.984 1.364.605 2.121"
		/>
	</g>
</svg>
